export const agencies = [
  {
    id: "a1",
    name: "LocaCar - Centro Campinas",
    address: "Av. Francisco Glicério, 1200 - Centro, Campinas - SP",
    hours: "Seg-Sex: 8h-20h | Sáb: 8h-18h | Dom: 9h-14h",
    phone: "(19) 3232-4500",
    distance: "0.8 km",
    lat: -22.9056,
    lng: -47.0608,
    vehicles: 24,
  },
  {
    id: "a2",
    name: "LocaCar - Shopping Iguatemi",
    address: "Rod. Dom Pedro I, km 131 - Jardim Flamboyant, Campinas - SP",
    hours: "Seg-Sáb: 10h-22h | Dom: 12h-20h",
    phone: "(19) 3787-6600",
    distance: "4.2 km",
    lat: -22.8697,
    lng: -47.0553,
    vehicles: 18,
  },
  {
    id: "a3",
    name: "LocaCar - Aeroporto Viracopos",
    address: "Rod. Santos Dumont, km 66 - Viracopos, Campinas - SP",
    hours: "24 horas - 7 dias por semana",
    phone: "(19) 3725-5000",
    distance: "12.5 km",
    lat: -23.0074,
    lng: -47.1345,
    vehicles: 35,
  },
  {
    id: "a4",
    name: "LocaCar - Barão Geraldo",
    address: "Av. Dr. Luís Barreto, 450 - Barão Geraldo, Campinas - SP",
    hours: "Seg-Sex: 8h-19h | Sáb: 9h-15h",
    phone: "(19) 3289-1100",
    distance: "8.1 km",
    lat: -22.8175,
    lng: -47.0694,
    vehicles: 12,
  },
  {
    id: "a5",
    name: "LocaCar - Hortolândia",
    address: "Av. Ruy Rodrigues, 3000 - Hortolândia - SP",
    hours: "Seg-Sex: 8h-18h | Sáb: 8h-14h",
    phone: "(19) 3865-2200",
    distance: "15.3 km",
    lat: -22.8578,
    lng: -47.2197,
    vehicles: 9,
  },
];
